import { AlertSeverity } from '@aloft/toolkit-shared';
import { Flex, IconButton, IconName, ProductColor, Tooltip } from '@aloft/toolkit-sui';

import { SubNavAlertBadge } from '../MainHeader/HeaderNav/SubNavAlertBadge.tsx';

type Props = {
  id?: string;
  label: string;
  icon: IconName;
  isSelected: boolean;
  formItem?: boolean;
  alertCount?: number;
  alertSeverity?: AlertSeverity;
  onClick: () => void;
};

export const Tkv2ReferenceBarItem = ({
  id,
  label,
  icon,
  isSelected,
  formItem,
  alertCount,
  alertSeverity,
  onClick,
}: Props) => {
  const hasAlerts = (alertCount ?? 0) > 0;
  const isAlertsItem = id === 'alerts';

  let backgroundColor: ProductColor = 'surface1';
  let borderColor: ProductColor = 'transparent';
  let iconColor: ProductColor = 'textTertiary';

  if (isSelected && isAlertsItem) {
    if (alertSeverity === 'error') {
      backgroundColor = 'alertErrorLight';
      borderColor = 'alertError';
      iconColor = 'alertError';
    } else {
      backgroundColor = 'alertWarningLight';
      borderColor = 'alertWarning';
      iconColor = 'statusWarning';
    }
  } else if (isSelected) {
    if (formItem) {
      backgroundColor = 'selected5';
      borderColor = 'surfaceAccent10';
      iconColor = 'surfaceAccent10';
    } else {
      backgroundColor = 'selected4';
      borderColor = 'surfaceAccent4';
      iconColor = 'surfaceAccent4';
    }
  } else if (hasAlerts) {
    if (alertSeverity === 'error') {
      iconColor = 'alertError';
    } else {
      iconColor = 'statusWarning';
    }
  } else if (formItem) {
    iconColor = 'surfaceAccent10';
  }

  return (
    <Flex
      backgroundColor={backgroundColor}
      borderRightWidth=".25rem"
      borderStyle="solid"
      borderRightColor={borderColor}
      width="100%"
      alignItems="center"
      justifyContent="center"
    >
      <Tooltip label={label} placement="left">
        <Flex position="relative">
          <IconButton
            id={id}
            ariaLabel={label}
            icon={icon}
            iconColor={iconColor}
            iconSize="lg"
            onClick={onClick}
            variant="tertiary"
            size="md"
          />
          {hasAlerts && (
            <Flex
              position="absolute"
              top="2px"
              right="2px"
              __dangerDoNotUseSx={{ pointerEvents: 'none' }}
            >
              <SubNavAlertBadge count={alertCount ?? 0} severity={alertSeverity} />
            </Flex>
          )}
        </Flex>
      </Tooltip>
    </Flex>
  );
};
